/** A track attached to a post (stored as a hidden post tag) or an event (a line in its description). */
export type AttachedTrack = { title: string; artist: string; artwork: string | null; previewUrl: string | null; spotifyUrl: string | null; appleUrl: string | null };

const PREFIX = "music:";

export const encodeMusicTag = (t: AttachedTrack) => PREFIX + JSON.stringify(t);

export const parseMusicTag = (tags: string[] | null | undefined): AttachedTrack | null => {
  const raw = (tags ?? []).find((t) => t.startsWith(PREFIX));
  if (!raw) return null;
  try {
    const t = JSON.parse(raw.slice(PREFIX.length));
    return typeof t?.title === "string" ? t : null;
  } catch { return null; }
};

export const isMusicTag = (t: string) => t.startsWith(PREFIX);

/** Plain-text soundtrack line for event descriptions (readable everywhere, no marker needed). */
export const soundtrackLine = (t: AttachedTrack) =>
  `🎵 Soundtrack: ${t.title} — ${t.artist}${t.spotifyUrl ? ` (${t.spotifyUrl})` : t.appleUrl ? ` (${t.appleUrl})` : ""}`;
